export enum Forms {
    loginForm = 'loginForm',
    profileForm = 'profileForm',
    resetPassForm = 'resetPassForm',
    registrationForm = 'registrationForm',
}
